import clsx from 'clsx'

import { ReactComponent as EditSvg } from '../../../../../../../assets/svgs/edit.svg'
import { ReactComponent as TrashSvg } from '../../../../../../../assets/svgs/secondary-trash.svg'
import { type TaskCommentDomain } from '../../../../../../../types/domain/task-comment-domain'
import { formatDate } from '../../../../../../../utils/date'

type CommentProps = {
  isActionsVisible: boolean
  isSelected: boolean
  comment: TaskCommentDomain
  hasBorderTop: boolean
  onEditComment: (selectedComment: TaskCommentDomain) => void
  onDeleteComment: (commentToBeDelete: TaskCommentDomain) => void
}

export const Comment = ({
  comment,
  isSelected,
  isActionsVisible,
  hasBorderTop,
  onDeleteComment,
  onEditComment
}: CommentProps) => {
  return (
    <div
      className={clsx({
        'bg-[#3DB9B9]/10': isSelected,
      })}
    >
      <div
        className={clsx('p-4 pl-0 ml-4 flex flex-row', {
          'border-t border-grey-200': hasBorderTop,
        })}
      >
        <div className="w-full">
          <div className="flex items-center justify-between">
            <strong className="text-sm font-bold text-grey-800">
              {comment.author.name}:
            </strong>

            {isActionsVisible && (
              <div className="inline-flex self-start space-x-2">
                <button type="button" onClick={() => onEditComment(comment)}>
                  <EditSvg
                    className={clsx('stroke-grey-700', {
                      'stroke-secondary-light': isSelected,
                    })}
                  />
                </button>

                <button type="button" onClick={() => onDeleteComment(comment)}>
                  <TrashSvg />
                </button>
              </div>
            )}
          </div>

          <p className="my-2 text-sm break-words text-grey-800 whitespace-pre-wrap">
            {comment.content}
          </p>

          <time className="text-xs text-grey-700">
            {formatDate(new Date(comment.createdAt), {
              dateStyle: 'short',
              timeStyle: 'short',
            })}
          </time>
        </div>
      </div>
    </div>
  )
}
